(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["popup-size-custom"] && !Shopify.designMode) return;
  try {
    window.showPopupWithAnimation = function() {
  const popup = document.getElementById('popup-size-custom');
  if (popup) {
    popup.style.display = 'block';
    setTimeout(() => {
      popup.classList.add('active');
    }, 10);
  }
};

window.closePopupWithAnimation = function() {
  const popup = document.getElementById('popup-size-custom');
  if (popup) {
    popup.classList.remove('active');
    setTimeout(() => {
      popup.style.display = 'none';
    }, 300);
  }
};

document.addEventListener('DOMContentLoaded', function() {
  const closeButton = document.querySelector('.popup-close');
  if (closeButton) {
    closeButton.addEventListener('click', window.closePopupWithAnimation);
  }
});
  } catch(e) { console.error(e); }
})();

})();
